"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISPFormSubmissionDirty = exports.ISPFormSubmissionClean = exports.ISPFormDirty = exports.ISPFormClean = exports.CleanReference = exports.ObjectReferenceType = exports.ISPFormCheckSeverity = void 0;
const firebase_1 = require("../bindings/firebase");
var ISPFormCheckSeverity;
(function (ISPFormCheckSeverity) {
    ISPFormCheckSeverity[ISPFormCheckSeverity["NONE"] = 0] = "NONE";
    ISPFormCheckSeverity[ISPFormCheckSeverity["WARNING"] = 1] = "WARNING";
    ISPFormCheckSeverity[ISPFormCheckSeverity["ERROR"] = 2] = "ERROR";
})(ISPFormCheckSeverity = exports.ISPFormCheckSeverity || (exports.ISPFormCheckSeverity = {}));
var ObjectReferenceType;
(function (ObjectReferenceType) {
    ObjectReferenceType["EVENT"] = "event";
})(ObjectReferenceType = exports.ObjectReferenceType || (exports.ObjectReferenceType = {}));
class CleanReference {
    constructor() {
        this.type = 'reference';
        this.value = '';
    }
}
exports.CleanReference = CleanReference;
function RefToClean(ref) {
    const clean = new CleanReference();
    clean.value = ref.path;
    return clean;
}
function TimestampToClean(ref) {
    const clean = new CleanReference();
    clean.type = 'timestamp';
    clean.value = ref.toDate().toISOString();
    return clean;
}
function CleanRefToDirty(clean) {
    return (0, firebase_1.fs)().doc(clean.value);
}
function CleanTimestampToDirty(clean) {
    return /* firebase.firestore.Timestamp.fromDate( */ new Date(clean.value) /* ) */;
}
function cleanValue(value) {
    if (!value) {
        return value;
    }
    let clean = value;
    if (Array.isArray(clean)) {
        return clean.map((d) => cleanValue(d));
    }
    if (clean instanceof firebase_1.firebase.firestore.DocumentReference) {
        clean = RefToClean(clean);
    }
    else if (clean instanceof firebase_1.firebase.firestore.Timestamp) {
        clean = TimestampToClean(clean);
    }
    else if (clean instanceof Date) {
        clean = TimestampToClean(firebase_1.firebase.firestore.Timestamp.fromDate(clean));
    }
    else if (typeof clean === 'object' && (clean === null || clean === void 0 ? void 0 : clean.constructor) === Object) {
        Object.keys(clean).forEach((key) => {
            clean[key] = cleanValue(clean[key]);
        });
    }
    return clean;
}
function dirtifyValue(clean) {
    if (!clean) {
        return clean;
    }
    let dirty = clean;
    if (Array.isArray(dirty)) {
        return dirty.map((d) => dirtifyValue(d));
    }
    // Skip values that are already "dirty" (Firebase objects)
    if (dirty instanceof firebase_1.firebase.firestore.DocumentReference) {
        return dirty;
    }
    if (dirty instanceof firebase_1.firebase.firestore.Timestamp) {
        return dirty;
    }
    if (typeof dirty === 'object' && 'type' in dirty) {
        if (dirty.type === 'reference') {
            dirty = CleanRefToDirty(dirty);
        }
        if (dirty.type === 'timestamp') {
            dirty = CleanTimestampToDirty(dirty);
        }
    }
    else if (typeof dirty === 'object' && dirty.constructor === Object) {
        Object.keys(dirty).forEach((key) => {
            dirty[key] = dirtifyValue(dirty[key]);
        });
    }
    return dirty;
}
function ISPFormClean(form) {
    const cleanForm = {
        ...form,
    };
    // if (cleanForm.edit_disable) {
    //     cleanForm.edit_disable.value = cleanValue(cleanForm.edit_disable.value);
    // }
    if (cleanForm.submit) {
        if (Array.isArray(cleanForm.submit)) {
            cleanForm.submit.forEach((submit) => {
                submit.value = cleanValue(submit.value);
            });
        }
        else {
            cleanForm.submit.value = cleanValue(cleanForm.submit.value);
        }
    }
    if (cleanForm.formFields) {
        cleanForm.formFields.forEach((ff) => {
            switch (ff.type) {
                case 'select':
                    switch (ff.value_type) {
                        case 'reference':
                            ff.default_value = cleanValue(ff.default_value);
                    }
                    break;
                // case 'date':
                // case 'daterange':
                //     ff.default_value = cleanValue(ff.default_value);
                //     break;
            }
        });
    }
    return cleanForm;
}
exports.ISPFormClean = ISPFormClean;
function ISPFormDirty(cleanForm) {
    const form = {
        ...cleanForm,
    };
    // if (form.edit_disable) {
    //     form.edit_disable.value = dirtifyValue(form.edit_disable.value);
    // }
    if (form.submit) {
        if (Array.isArray(form.submit)) {
            form.submit.forEach((submit) => {
                submit.value = cleanValue(submit.value);
            });
        }
        else {
            form.submit.value = cleanValue(form.submit.value);
        }
    }
    if (form.formFields) {
        form.formFields.forEach((ff) => {
            switch (ff.type) {
                case 'select':
                    switch (ff.value_type) {
                        case 'reference':
                            ff.default_value = dirtifyValue(ff.default_value);
                    }
                    break;
                // case 'date':
                // case 'daterange':
                //     ff.default_value = dirtifyValue(ff.default_value);
                //     break;
            }
        });
    }
    return form;
}
exports.ISPFormDirty = ISPFormDirty;
function ISPFormSubmissionClean(submission, form) {
    const cleanSubmission = {
        ...submission,
    };
    Object.keys(cleanSubmission).forEach((key) => {
        cleanSubmission[key] = cleanValue(cleanSubmission[key]);
    });
    if (form) {
        form.formFields.forEach((ff) => {
            if (!ff.public) {
                delete cleanSubmission[ff.key];
            }
        });
    }
    return cleanSubmission;
}
exports.ISPFormSubmissionClean = ISPFormSubmissionClean;
function ISPFormSubmissionDirty(cleanSubmission) {
    const submission = {
        ...cleanSubmission,
    };
    Object.keys(submission).forEach((key) => {
        submission[key] = dirtifyValue(submission[key]);
    });
    return submission;
}
exports.ISPFormSubmissionDirty = ISPFormSubmissionDirty;
//# sourceMappingURL=forms.js.map